import { Image } from 'app/src/shared/components'
import { useWelfarePortalNavigate } from 'app/src/shared/hooks'
import successImage from 'app/static/images/adesione_non_avvenuta.png'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function UnjoinSuccess() {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Confirm.cancelJoinSection.unjoinSuccess' })
  const navigate = useWelfarePortalNavigate()
  return (
    <div className='mt-2 flex'>
      <div className='mx-auto'>
        <Image
          pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
          src={successImage}
          alt='Immagine di successo'
        />
        <div className='mx-auto my-4 text-center' dangerouslySetInnerHTML={{ __html: t('trailer') }} />
        <div className='mx-auto flex justify-center'>
          <Button rounded label={t('goToLandingBtnLabel')} className='my-5' onClick={navigate.goToLanding}></Button>
        </div>
        <div className='mx-auto my-4 text-center'>
          <Button link label={t('footer')} onClick={navigate.goToCatalog} />
        </div>
      </div>
    </div>
  )
}
